import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React, { useState } from 'react';
import { Grid } from '@instinet-analytics/semantic-ui-components';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';
import { MeasureUserAgentSpecificMemoryTimestampedResult } from 'performance/MemoryMonitoringService';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import './MeasuredMemory.scss';

export default function MeasuredMemoryPanel(props: VisualisationContextProps) {
    const { state, height, width } = props;

    const [selectedResult, setSelectedResult] = useState<
        MeasureUserAgentSpecificMemoryTimestampedResult | undefined
    >();

    const results = state?.measuredMemory ?? [];

    if (results.length === 0) {
        return <div>None found in state</div>;
    }

    const columnDefs = getColumns();

    const onSelectedRowIdsChanged = (rowDataIds: string[]) => {
        if (rowDataIds.length !== 1) {
            setSelectedResult(undefined);
        }
        const row = results.find(
            (r) => r.timeStamp.getTime().toString() === rowDataIds[0]
        );
        setSelectedResult(row);
    };

    const panelHeight = height / 2;

    const panelStyle = { height: panelHeight, width };

    return (
        <div className={'MeasuredMemoryPanel'}>
            <Grid
                autoSizeColumns={true}
                singleSelectOnly={true}
                columnDefs={columnDefs}
                rowData={results}
                getRowDataId={(r) => r.timeStamp.getTime().toString()}
                onSelectedRowIdsChanged={onSelectedRowIdsChanged}
            />
            {selectedResult && (
                <div className="SelectedResult" style={panelStyle}>
                    <JsonPanel data={selectedResult} />
                </div>
            )}
        </div>
    );
}

function getColumns(): ColDef[] {
    return [
        {
            field: 'timeStamp',
            headerName: 'Time',
            resizable: true,
            width: 80,
            cellRenderer: (props: { value: Date }) => {
                return <span>{toDateString(props.value)}</span>;
            },
        },
        {
            field: 'result.bytes',
            headerName: 'Bytes',
            width: 100,
            resizable: true,
        },
    ];
}
